var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none",
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#136DF4",
    d: "M25.88 9.88l-6.44-6.44c-.494-.494-1.174-.774-1.88-.774H8c-1.467 0-2.654 1.2-2.654 2.667l-.013 21.333c0 1.467 1.187 2.667 2.653 2.667H24c1.466 0 2.666-1.2 2.666-2.667V11.773c0-.707-.28-1.387-.786-1.894zM19.733 20h-2.4v4c0 .733-.6 1.333-1.333 1.333-.734 0-1.334-.6-1.334-1.334v-4H12.28c-.6 0-.894-.72-.467-1.133l3.733-3.72c.267-.253.68-.253.947 0l3.72 3.72c.4.413.107 1.133-.48 1.133zm-1.067-8c-.733 0-1.333-.6-1.333-1.334v-6l7.333 7.333h-6z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadIcon);
export default __webpack_public_path__ + "static/media/upload-icon.5009ab5fb5c5a84cb24093f711fb38e2.svg";
export { ForwardRef as ReactComponent };